import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetricsHttpService } from '@/app/core';
import { CoreModule } from '@/app/core/core.module';
import { AuthenticationService } from '@/app/core/authentication/authentication.service';
import { FilterModule } from '@/app/filter/filter.module';
import { CoreServicesModule } from '@/app/core/core-services.module';
import { LogService } from '@/app/core/services/log.service';

import { SavedViewsService } from './saved-views.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, CoreModule, FilterModule, CoreServicesModule],
  providers: [
    MetricsHttpService,
    AuthenticationService,
    SavedViewsService,
    LogService,
  ],
  exports: [],
})
export class SavedViewsModule {}
